import { SecondaryButton } from 'ui_kit_qmd'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import moment from 'moment-timezone'
import { VISIT_TEXT, CLOSE_TEXT } from '../../../../utils/constants'
import './PastVisitInfoHeader.scss'
import { parseUserDateTime } from '../../../../utils/common'

const closeBtnLabelStyle = {
  fontWeight: '700',
  fontSize: 20,
}

const closeBtnContainerStyle = {
  height: 38,
  width: 200,
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const PastVisitInfoHeader = ({ clickClose, visitTime, userTimeZone }) => (
  <div className='past-visit-info-header'>
    <div className='past-visit-info-header-date-time'>
      {VISIT_TEXT}: {parseUserDateTime(visitTime, userTimeZone, true)}
    </div>
    <SecondaryButton
      id='past-visit-info-header-close-button'
      btnText={CLOSE_TEXT}
      onPress={clickClose}
      labelStyle={closeBtnLabelStyle}
      containerStyle={closeBtnContainerStyle}
    />
  </div>
)
